import React from 'react';
import Layout from '../Shared/Layout';
import {Container, Grid, Paper} from "@material-ui/core";
import styled from "styled-components";
import {InertiaLink} from "@inertiajs/inertia-react";
import {Trans} from "../utils/i18n";

export default function Home({ user }) {
    return (
        <div className={'-mt-12 '}>
            <div className={`w-full bg-[#3D5166] pb-16`}>
                <div className={``}>
                    <Container maxWidth="lg" >
                        <div className={`z-10 relative w-full text-white flex flex-col items-center bg-contain bg-bottom bg-no-repeat`}>
                            <div className={'w-full grid-cols-1 md:grid-cols-2 grid gap-6 min-h-[50vh]'}>
                                <div className={'col-1 flex justify-center items-left flex-col '}>
                                    <div className={'w-full md:w-2/3'}>
                                        <h2 className={'m-0'}>
                                            <Trans i18nKey={'carbon.welcomeTo'}>
                                                Welcome to the B2X
                                            </Trans></h2>
                                        <h1 className={'m-0 text-5xl'}>
                                            <Trans i18nKey={'carbon.productLifecycleCarbonCalc'}>
                                                Product Lifecycle Carbon Calculator
                                            </Trans>
                                        </h1>
                                        <p className={'text-xl'}>
                                            <Trans i18nKey={'carbon.description'}>
                                                Our Product Lifecycle Carbon Calculator empowers you to manage hardware lifecycles towards carbon net zero. It calculates, measures, and reports product carbon footprints (PCF), specifically focusing on Scope 3 emissions. Try out the calculator directly for yourself.
                                            </Trans>
                                        </p>
                                    </div>
                                </div>
                                <div className={'col-1 flex justify-center items-center -my-10'}>
                                    <img src={'/images/b2x_home.png'} alt={'hero'} className={'w-full '}/>
                                </div>
                            </div>
                            <div className={'w-full grid-cols-1 md:grid-cols-2 grid gap3 md:gap-6'}>
                                <div className={'mb-8 w-full flex flex-col items-start justify-between max-w-4xl bg-white/60 backdrop-blur rounded-2xl p-9 text-black'}>
                                    <h1 className={'text-3xl font-bold m-0'}>
                                        <Trans i18nKey={'carbon.singleMode'}>
                                            Single Device Comparison
                                        </Trans>
                                    </h1>
                                    <p className={'text-lg font-medium mt-4 mb-4'}>
                                        <Trans i18nKey={'carbon.singleMode.description'}>
                                            Understand the CO2e savings and benefits of repairing your device versus replacing it with a new one
                                        </Trans>
                                    </p>
                                    <InertiaLink className={'no-underline block font-bold bg-[#3D5166] rounded-md text-white px-9 py-3  hover:bg-[#2A5B97] hover:text-white shadow-lg'} href={route('emissions.index')}>Calculate</InertiaLink>
                                </div>
                                <div className={'mb-8 w-full flex flex-col items-start justify-between max-w-4xl bg-white/60 backdrop-blur rounded-2xl p-9 text-black'}>
                                    <h1 className={'text-3xl font-bold m-0'}>
                                        <span style={{
                                            background: "linear-gradient(90deg, #FF4F50 0%, #F13B5F 100%)",
                                            backgroundClip: "text",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                        }}>Enterprise</span>
                                        { ' ' }Tool
                                    </h1>
                                    <p className={'text-lg font-medium mt-4 mb-2´4'}>
                                        <Trans i18nKey={'carbon.enterpriseMode.description'}>
                                            Access the enterprise tool to calculate the positive CO2e impact of repairing large volumes of devices
                                        </Trans>
                                    </p>
                                    {
                                        !user &&
                                        <a className={'no-underline block font-bold bg-white rounded-md text-[#2A5B97] px-9 py-3  hover:bg-[#2A5B97] hover:text-white shadow-lg'} href={'https://www.b2x.com/demo'} target={'_blank'}>
                                            <Trans i18nKey={'carbon.getInTouch'}>
                                                Get in touch
                                            </Trans>
                                        </a>
                                    }
                                    {
                                        user &&
                                        <InertiaLink className={'no-underline block font-bold bg-white rounded-md text-[#2A5B97] px-9 py-3  hover:bg-[#2A5B97] hover:text-white shadow-lg'} href={route('emissions.enterprise')}>
                                            <Trans i18nKey="emissions.co2CalcEnterprise">CO2e Calculator for Enterprise</Trans>
                                        </InertiaLink>
                                    }
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </div>
        </div>
    )
}

Home.layout = page => <Layout children={page} />;
